import { render, staticRenderFns } from "./m-showdown.vue?vue&type=template&id=b16c8c96&scoped=true&"
import script from "./m-showdown.vue?vue&type=script&lang=js&"
export * from "./m-showdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16c8c96",
  null
  
)

export default component.exports